export default "__VITE_ASSET__CUyVZa8i__"